import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  CircularProgress,
} from "@mui/material";
import { getPODById } from "../../app/services/OrdersService";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const GetOrdersData: React.FC = () => {
  const { id } = useParams();
  const [podData, setPodData] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchPOD = async () => {
      try {
        if (!id) return;
        const res = await getPODById(Number(id));
        if (res.status === "success") {
          setPodData(res.data);
        } else {
          toast.error("Failed to fetch POD details");
        }
      } catch (error) {
        toast.error("Failed to fetch POD details");
      } finally {
        setLoading(false);
      }
    };

    fetchPOD();
  }, [id]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={5}>
        <CircularProgress />
      </Box>
    );
  }

  if (!podData) return null;

  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight={600} mb={2}>
        POD Details
      </Typography>

      <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
        <Typography variant="subtitle1">
          <strong>Return ID:</strong> {podData.id}
        </Typography>
        <Typography variant="subtitle1">
          <strong>Order ID:</strong> {podData.order?.unique_id}
        </Typography>
        <Typography variant="subtitle1">
          <strong>Date:</strong> {new Date(podData.created_at).toLocaleString()}
        </Typography>
        <Typography variant="subtitle1">
          <strong>Total Amount:</strong> ₹{podData.order?.total_amount}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          Vehicle Info
        </Typography>
        <Typography>
          <strong>Name:</strong> {podData.vehicle?.vehicle_name}
        </Typography>
        <Typography>
          <strong>Reg No:</strong> {podData.vehicle?.vehicle_reg_no}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          POD Images
        </Typography>
        <Box display="flex" gap={2} flexWrap="wrap">
          {podData.images?.map((img: any) => (
            <img
              key={img.id}
              src={img.name}
              alt="POD"
              width="120"
              height="120"
              style={{ borderRadius: "8px", objectFit: "cover" }}
            />
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default GetOrdersData;
